import {
  predicateValueEditorStyle,
  editImageCommonStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { getCommonPreviewContainerStyles } from '@bingads-webui-campaign-react/shared-image-preview-styles';

import { palette } from './palette';

const panelStyle = () => ({
  '& .panel-body': {
    height: '100%',
    marginBottom: '65px',
  },
});

const floatButtonStyle = () => ({
  floatButton: {
    background: palette.neutralLighter,
    border: 'none',
    borderRadius: 0,
    color: palette.themeDarkAlt,
    fontWeight: 'normal',
    height: 'auto',
    minHeight: 'auto',
    minWidth: 'auto',
    width: 'auto',
    padding: '14px 8px',

    '&:active, &:focus, &:hover': {
      color: palette.themeDark,
      background: palette.neutralQuaternaryAlt,
    },
  },
});

const paginationStyle = ({ iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .ba-pagination, .dlb-pager-container, .pagination-control': {
    height: 'auto',
    padding: '6px 0',

    '& > .text': {
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '0px 0px 8px 5px',
      '& > span': {
        marginRight: '5px',
      },
    },
    '& button': {
      border: 0,
      background: 'transparent',
      minWidth: '1px',
      padding: 0,
      color: palette.neutralSecondary,
    },

    '& button:hover': {
      borderRadius: 2,
      background: palette.neutralLighter,
    },

    '& button:disabled': {
      background: 'transparent',
      color: '#BEBBB8',
    },

    '& .pager-input': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: '6px 8px',
      height: 32,
      textAlign: 'center',
      margin: '0 12px',
      width: 70,
      display: 'inline-block',
      borderRadius: 2,
      boxSizing: 'border-box',
      color: palette.neutralPrimary,
    },

    '& .glyphicon-triangle-left, & .glyphicon-triangle-right': {
      display: 'inline-block',
      fontFamily: iconFontFamily,
      color: 'inherit',
    },

    '& .glyphicon-triangle-left:before': {
      content: '"\\E76B"',
    },

    '& .glyphicon-triangle-right:before': {
      content: '"\\E76C"',
    },
  },

  '& .pager, .location-bid-pager-view': {
    height: 32,
    padding: 0,
    margin: 0,

    '& .pager-input, .page-number-input, .grid-pager-input': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: '6px 8px',
      height: 32,
      textAlign: 'center',
      margin: '0 12px',
      width: 70,
      display: 'inline-block',
      borderRadius: 2,
      boxSizing: 'border-box',
      color: palette.neutralPrimary,
      background: palette.white,
    },

    '& .pager-input[disabled], & .page-number-input[disabled], & .grid-pager-input[disabled]': {
      backgroundColor: palette.neutralLighter,
    },

    '& .pager-previous, & .pager-next, & .glyphicon-triangle-left, & .glyphicon-triangle-right': {
      fontFamily: iconFontFamily,
      color: palette.neutralSecondary,
      background: 'transparent',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '2px 5px',
      height: 32,
      lineHeight: '32px',
      marginTop: '-7px',
      outline: 'none',
    },

    '& .pager-previous, & .pager-next': {
      '&:focus': {
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: '-2px',
      },
    },

    '& .pager-previous:hover, & .pager-next:hover': {
      borderRadius: 2,
      background: palette.neutralLighter,
    },

    '& .pager-previous-disabled, & .pager-next-disabled': {
      fontFamily: iconFontFamily,
      color: '#BEBBB8',
      background: 'transparent',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '2px 5px',
      height: 32,
      lineHeight: '32px',
      marginTop: '-7px',
    },

    '& .pager-previous-disabled:before, & .pager-previous:before': {
      content: '"\\E76B"',
    },

    '& .pager-next-disabled:before, & .pager-next:before': {
      content: '"\\E76C"',
    },

    '& .pager-totalCount': {
      verticalAlign: 'unset',
      marginLeft: 4,
    },
  },

  '& .pagination-control': {
    textAlign: 'left',

    '& .text': {
      display: 'inline-block',
      width: 'auto',
    },

    '& .page-size-selector': {
      border: `1px solid ${palette.neutralSecondary}`,
      height: 32,
      textAlign: 'center',
      margin: '0 12px',
      width: '70px !important',
      display: 'inline-block',
      borderRadius: 2,
      boxSizing: 'border-box',
      color: palette.neutralPrimary,
    },
  },

});

export const btnStyle = () => {
  const primary = {
    height: 32,
    minWidth: 80,
    background: palette.themePrimary,
    borderRadius: 2,
    textAlign: 'center',
    color: palette.white,
    boxSizing: 'border-box',

    '&:hover': {
      background: palette.themeDarkAlt,
    },

    '&:focus': {
      background: palette.themePrimary,
      outline: 'none',
    },

    '&:active': {
      background: palette.themeDark,
    },

    '&:disabled': {
      background: palette.neutralLighter,
      color: palette.neutralTertiary,
    },
  };

  return {
    '.btn-primary': primary,
    '.btn-hero': primary,

    '.btn-default': {
      height: 32,
      minWidth: 80,
      background: palette.white,
      borderRadius: 2,
      textAlign: 'center',
      color: palette.neutralPrimary,
      border: `1px solid ${palette.neutralSecondaryAlt}`,

      '&:hover': {
        background: palette.neutralLighter,
      },

      '&:focus': {
        background: palette.neutralLight,
      },

      '&:disabled': {
        background: palette.neutralLighter,
        color: palette.neutralTertiary,
      },
    },
  };
};

const controlStyle = () => ({
  '.form-control': {
    '-webkit-box-shadow': 'none',
    backgroundColor: palette.white,
    backgroundImage: 'none',
    border: `1px solid ${palette.neutralSecondary}`,
    borderRadius: 2,
    boxShadow: 'none',
    color: palette.neutralPrimary,
    display: 'block',
    fontSize: 14,
    height: 32,
    lineHeight: 1.5,
    padding: '6px 12px',
    transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',

    '&:active': {
      borderColor: palette.themePrimary,
    },

    '&:hover': {
      borderColor: palette.neutralPrimary,
    },

    '&:focus': {
      '-webkit-box-shadow': 'none',
      borderColor: palette.themePrimary,
      boxShadow: 'none',
      outline: 0,
    },
  },
});

const addEditCommonStyle = ({ iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .add-image-content, & .image-edit-content': {
    fontSize: 14,
    lineHeight: '20px',
    position: 'relative',

    '& .add-image-label, & .edit-image-title': {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '27px',
      marginBottom: 16,
    },

    '& .add-image-description': {
      marginBottom: 20,
      paddingBottom: 32,
      borderBottom: `1px solid ${palette.neutralSecondary}`,
    },

    '& .image-preview-crop-description': {
      fontSize: 14,
      lineHeight: '20px',
      margin: '0 0 32px 0',
    },

    '& .image-cropper-ratio-label': {
      fontSize: 14,
      fontWeight: 'normal',
      lineHeight: '20px',
      margin: '16px 0',
    },

    '& .close-dialog-button': {
      backgroundColor: 'transparent',
      color: palette.neutralSecondary,
      fontFamily: iconFontFamily,
      fontSize: 12,
      lineHeight: 1,
      position: 'absolute',
      right: 0,
      top: 0,
      border: 'none',
      background: 'none',

      '&:before': {
        content: '"\\E711"',
      },
    },

    '& .search-box-container': {
      width: '40%',
      display: 'flex',
      alignItems: 'center',

      '& .search-box__input-group': {
        display: 'flex',

        '& input.search-box__input': {
          color: palette.neutralSecondary,
          marginLeft: -32,
          padding: '6px 8px 6px 32px',
          order: 1,
        },

        '& .search-box__icon': {
          position: 'relative',
          fontFamily: iconFontFamily,
          fontSize: 16,
          lineHeight: 1,
          order: 0,
          padding: 8,

          '&:before': {
            content: '"\\E721"',
          },
        },
      },

      '& .ba-search-box': {
        flex: 1,
      },

      '& .clear-search': {
        marginLeft: 10,
        border: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        fontFamily: iconFontFamily,
      },
    },

    '& .sort-by-label': {
      display: 'none',
    },

    '& .dropdown-selector-container': {
      float: 'right',
      minWidth: '25%',

      '& .dropdown-toggle': {
        background: 'url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ODQ2NDQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMS4zNyw0bC41Mi41M0w2LDEwLjQ1LjEyLDQuNTYuNjQsNCw2LDkuNFoiLz48L3N2Zz4=") no-repeat right 8px top 8px transparent',
        backgroundSize: '14px 14px',
        borderColor: palette.neutralSecondary,
        borderRadius: 2,
        boxShadow: 'none',
        color: palette.neutralPrimary,
        fontWeight: 'normal',
        height: 32,
        padding: '0px 28px 0px 8px',
        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        width: '100%',
        '-webkit-box-shadow': 'none',
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',

        '&:active': {
          borderColor: palette.themePrimary,
        },

        '&:focus': {
          borderColor: palette.themePrimary,
          outline: 0,
        },

        '&:hover': {
          borderColor: palette.neutralPrimary,
        },

        '& span': {
          margin: 'auto 0',
        },

        '& .glyphicon-triangle-bottom': {
          display: 'none',
        },
      },
    },

    '& .image-picker-container': {
      '& .image-name-section': {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: 5,
        marginBottom: 5,

        '& .image-name': {
          position: 'relative',
          left: 0,
          bottom: 0,
          width: 'auto',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },

        '& .glyphicon-pencil': {
          border: 'none',
          background: 'none',
          color: palette.themeDark,
          display: 'inline',
          fontFamily: iconFontFamily,
          paddingLeft: 8,
          position: 'relative',
          top: 'unset',
          right: 'unset',

          '&:before': {
            content: '"\\E70F"',
          },
        },
      },

      '& .image-name-container': {
        background: palette.white,
        border: 'rgba(0, 0, 0, 0.2)',
        boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
        position: 'absolute',
        top: 90,
        left: 0,
        margin: 1,
        padding: 16,
        minWidth: 240,
        width: 'max-content',
        zIndex: 9,
        display: 'grid',
        gridTemplateColumns: 'auto auto 1fr',

        '& .image-name-input': {
          extend: controlStyle()['.form-control'],
          gridColumnStart: '1',
          gridColumnEnd: 'span 3',

          '& + button': {
            extend: btnStyle()['.btn-primary'],
          },
        },

        '& #image-name-field': {
          width: '100%',
        },

        '& button': {
          marginLeft: 0,
          marginTop: 16,

          '& ~ button': {
            marginLeft: 8,
          },
        },
      },

      '& .replace-failed-video': {
        position: 'absolute',
        right: 43,
        bottom: 30,
        padding: '13px 5px',
        border: 'none',
      },

      '& .replace-failed-video:hover': {
        background: '#e1dfdd',
      },

      '& button.glyphicon-remove': {
        extend: floatButtonStyle().floatButton,
        position: 'absolute',
        top: 'unset',
        right: 5,
        bottom: 31,
        fontFamily: iconFontFamily,
        fontSize: 16,
        lineHeight: 1,
        float: 'right',
        borderRadius: 0,

        '&:before': {
          content: '"\\E711"',
        },

        '&.circular-hover': {
          backgroundColor: `${palette.white}d4`,
          padding: 0,
          borderRadius: 0,
          height: 32,
          width: 32,
          right: 0,
          bottom: 36,
        },

        '&.circular-hover:hover': {
          backgroundColor: `${palette.themeDarkAlt}ff`,
          '&:before': {
            color: palette.white,
          },
        },
      },

      '& .image-delete.glyphicon.glyphicon-remove': {
        display: 'inline',
      },

      '& .image-info-section': {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        whiteSpace: 'nowrap',
        '& .image-id': {
          fontWeight: 'inherit',
          padding: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    },

    '& .image-picker': {
      background: 'none',
      border: 'none',
      margin: '16px 0',
      padding: 0,

      '& .existing-images': {
        display: 'flex',
        flexWrap: 'wrap',
        height: 'auto',
        justifyContent: 'space-between',

        '& .existing-image-container': {
          display: 'inline-flex',
          margin: '0 0 24px 0',
          paddingBottom: 20,

          '& .image-section-wrapper': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: 202,
            width: 202,

            '& .image-section': {
              position: 'relative',

              '& .image-dimensions': {
                display: 'none',
              },

              '& button.existing-image': {
                border: '1px solid transparent',

                '&:before': {
                  fontFamily: iconFontFamily,
                  fontSize: 18,
                  position: 'absolute',
                  right: 5,
                  top: 5,
                },

                '& img': {
                  margin: 0,
                  maxHeight: 200,
                  maxWidth: 200,
                },
              },

              '&:active button.existing-image': {
                border: `1px solid ${palette.themePrimary}`,

                '&:before': {
                  color: palette.themePrimary,
                  content: '"\\ECCB"',
                },
              },

              '&:focus button.existing-image': {
                border: `1px solid ${palette.neutralSecondary}`,
              },

              '&:hover button.existing-image': {
                border: `1px solid ${palette.neutralPrimary}`,

                '&:before': {
                  color: palette.neutralPrimary,
                  content: '"\\ECCA"',
                },
              },

              '& button.glyphicon-remove': {
                extend: floatButtonStyle().floatButton,
                position: 'absolute',
                top: 'unset',
                right: 1,
                bottom: 1,
                fontFamily: iconFontFamily,
                fontSize: 16,
                lineHeight: 1,
                float: 'right',

                '&:before': {
                  content: '"\\E711"',
                },
              },
            },
          },

          '& .image-name-section': {
            bottom: 0,
            left: 0,
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',

            '& .image-name': {
              position: 'relative',
              left: 0,
              bottom: 0,
              width: 'auto',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },

            '& .glyphicon-pencil': {
              border: 'none',
              background: 'none',
              color: palette.themeDark,
              display: 'inline',
              fontFamily: iconFontFamily,
              paddingLeft: 8,
              position: 'relative',
              top: 'unset',
              right: 'unset',

              '&:before': {
                content: '"\\E70F"',
              },
            },
          },

          '& .image-name-container': {
            background: palette.white,
            border: 'rgba(0, 0, 0, 0.2)',
            boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
            left: 0,
            margin: 1,
            padding: 16,
            width: 220,
            zIndex: 9,

            '& .image-name-input': {
              extend: controlStyle()['.form-control'],

              '& + button': {
                extend: btnStyle()['.btn-primary'],
              },
            },

            '& #image-name-field': {
              width: '100%',
            },

            '& button': {
              marginLeft: 0,
              marginTop: 16,

              '& ~ button': {
                marginLeft: 8,
              },
            },
          },

          '& .image-delete.glyphicon.glyphicon-remove': {
            display: 'inline',
          },
        },
      },
    },

    '& .ba-pagination': {
      display: 'block',
      textAlign: 'center',
    },

    '& .choose-file-description': {
      borderTop: `1px solid ${palette.neutralSecondary}`,
      paddingTop: 32,
    },

    '& .edit-url-description': {
      paddingTop: 16,
    },

    '& .file-picker-react-wrapper': {
      margin: 0,
      padding: '14px 0 0 0',
      width: '100%',

      '& .file-picker-btn': {
        extend: btnStyle()['.btn-default'],
        display: 'inline-block',
        float: 'none',
        marginLeft: 0,

        '& ~ .file-text': {
          display: 'inline-block',
          border: 'none',
        },
      },
    },

    '& .file-drag-container': {
      position: 'relative',
      width: '100%',
      height: '190px',
      marginTop: '8px',
      overflow: 'hidden',

      '& .file-picker-react-wrapper': {
      },

      '& .file-picker-react-wrapper.disabled': {
        display: 'none',
      },
    },

    '& .add-image-button-bar, & .image-edit-actions': {
      borderTop: '1px solid #EDEBE9',
      bottom: 0,
      margin: '0 -16px',
      padding: '16px',
      position: 'fixed',
      width: '100%',

      '& button ~ button': {
        marginLeft: 12,
      },
    },

    '& .image-cropper-in-edit': {
      margin: 0,
      padding: 0,
    },

    '& .edit-preview-section': {
      display: 'flex',

      '& .edit-section': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },

    '& > .error': {
      color: '#A80000',
      fontSize: 12,
      margin: '4px 0 0 0',
    },

    '& .HelpTopic, & .a': {
      color: '#106ebe',
      textDecoration: 'underline',
    },
  },
});

export const getEditImageStyle = (_, { iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  editImageStyle: {
    '& .image-edit-content .edit-image-title': {
      fontSize: 14,
      fontFamily: '"Segoe UI"',
      fontWeight: '400',
      fontStyle: 'normal',
    },
    '& .image-edit-content .close-dialog-button': {
      top: 10,
      right: 5,
    },
    '& .image-edit-content .image-preview-crop-description': {
      fontSize: 12,
      margin: '10px 0',
    },
    '& .image-edit-content .image-cropper-in-edit': {
      padding: 5,
      marginTop: 30,
    },
    '& .image-edit-content .image-cropper-in-edit .image-cropper-ratio-label': {
      fontSize: 12,
      margin: '10px 0 5px 0',
      width: '100%',
      fontWeight: '700',
      textAlign: 'center',
    },
    '& .image-edit-content .image-replace-description': {
      fontSize: 12,
      margin: '10px 0',
    },
    '& .image-edit-content .preview-section': {
      border: '1px solid #CCCCCC',
    },
    '& .image-edit-content .image-edit-actions': {
      marginTop: 40,
    },
    '& .edit-image-content-container': {
      minWidth: 1350,
      width: 1350,
    },
    ...getCommonPreviewContainerStyles(),
    ...addEditCommonStyle({ iconFontFamily }),
    ...paginationStyle({ iconFontFamily }),
    ...panelStyle(),
    ...editImageCommonStyle(),
  },
  previewPlacementContainerRoot: {
    display: 'flex',
    '& > div:first-child': {
      top: -20,
    },
  },
  adPreviewCarousel133x100Container: {
    '& .ad-placement-card-preview .carousel-control': {
      '& .glyphicon-chevron-left, & .glyphicon-chevron-right': {
        top: '5px !important',
      },
    },
  },
});

export const getAddImageStyle = (_, { iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  addImageStyle: {
    '& .video-inactive': {
      paddingTop: 60,
    },
    '& .video-inactive:hover': {
      cursor: 'not-allowed',
    },
    '& .add-image-content': {
      fontSize: 12,
      position: 'relative',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    ['& .image-selector-for-thumbnail .user-image-picker-container .image-picker-container,' +
    '& .image-selector-for-thumbnail .stock-image-picker-container .image-picker-container']: {
      maxHeight: '50vh',
      maxWidth: '60vw',
    },
    ['& .user-image-picker-container, .stock-image-picker-container, .image-suggestion-picker-container' +
    ', .image-suggestion-picker-container > .react-block-ui-none, .image-suggestion-picker-container > .react-block-ui-none > .react-block-ui-none, .image-suggestion-picker-container > .react-block-ui-none > .react-block-ui']: {
      flexGrow: 1,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
    '& .social-media-container': {
      flexGrow: 1,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& .suggestion-error-invalid': {
        marginTop: 16,
        textAlign: 'center',
        color: 'red',
      },
      '& .suggestion-error img': {
        marginLeft: 129,
        marginBottom: 24,
      },
      '& .desc': {
        width: '100%',
      },
    },
    '& .add-image-content .disable-mouse': {
      pointerEvents: 'none',
    },
    '& .add-image-content .add-image-label': {
      marginBottom: 15,
      fontSize: 14,
      fontFamily: '"Segoe UI"',
      fontWeight: '400',
      fontStyle: 'normal',
    },
    '& .add-image-description': {
      marginBottom: 20,
      paddingBottom: 32,
      borderBottom: `1px solid ${palette.neutralSecondary}`,
    },
    '& .add-image-content .add-image-description': {
      marginBottom: 5,
    },
    '& .add-image-content .search-box-container': {
      width: '45%',
      float: 'left',
    },
    '& .add-image-content .search-box-container .search-box__input-group .search-box__input.form-control': {
      borderRadius: '0',
    },
    '& .add-image-content .search-box-container .search-box__input-group .search-box__icon': {
      fontSize: 12,
    },
    '& .add-image-content .add-image-button-bar': {
      marginTop: 15,
    },
    '& .add-image-content .dropdown-selector-container': {
      float: 'right',
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector': {
      position: 'relative',
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector button.dropdown-toggle': {
      borderRadius: '0',
      minWidth: 190,
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector button.dropdown-toggle .icon-right.glyphicon-triangle-bottom': {
      paddingTop: 3,
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-content': {
      border: 'none',
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .empty-message': {
      position: 'absolute',
      padding: '5px 10px',
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item': {
      padding: '5px 10px',
      margin: '0',
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item:hover': {
      cursor: 'pointer',
      backgroundColor: '#f5f5f5',
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item.selected': {
      background: '#E7F0F6',
    },
    '& .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item .item-actions': {
      float: 'right',
    },
    '& .add-image-content .sort-by-label': {
      paddingTop: 9,
      paddingRight: 5,
      float: 'right',
    },
    '& .add-image-content .image-picker': {
      marginTop: 15,
      marginBottom: 5,
      backgroundColor: '#f4f4f4',
      padding: 15,
      border: '1px solid #bbb',
    },
    '& .add-image-content .image-picker .existing-images': {
      overflowY: 'auto',
      height: 400,
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container': {
      position: 'relative',
      display: 'inline-block',
      padding: '0',
      margin: 10,
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container:hover .image-dimensions, .add-image-content .image-picker .existing-images .existing-image-container:hover .image-edit.glyphicon.glyphicon-pencil, .add-image-content .image-picker .existing-images .existing-image-container:hover .image-delete.glyphicon.glyphicon-remove': {
      display: 'inline',
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .existing-image': {
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      border: 'none',
      background: 'none',
      padding: '0',
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .existing-image img': {
      margin: 15,
      width: 225,
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .image-dimensions': {
      display: 'none',
      position: 'absolute',
      bottom: 15,
      left: 15,
      textIndent: 5,
      color: 'white',
      backgroundColor: 'rgba(27,27,27,0.616)',
      width: 225,
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .image-name-container': {
      position: 'absolute',
      left: 15,
      bottom: '0',
      marginBottom: -15,
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .image-name-container input': {
      width: 100,
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .image-name-container button': {
      marginLeft: 3,
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .image-name-container [role=alert]': {
      position: 'absolute',
    },
    '& .add-image-content .image-picker .existing-images .existing-image-container .image-name': {
      position: 'absolute',
      width: 225,
      left: 15,
      bottom: '0',
      marginBottom: -5,
      textAlign: 'center',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    '& .existing-image-container .upload-progress': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    '& .add-image-content .file-picker-react-wrapper': {
      marginTop: 5,
      marginBottom: 5,
    },
    '& .add-image-content .pagination-control-container': {
      marginBottom: 10,
    },
    '& .add-image-content .pagination-control-container .ba-pagination>*': {
      display: 'inline',
    },
    '& .add-image-content .pagination-control-container .pager-input': {
      border: '1px solid #BBB',
      width: 25,
      padding: '0 3px',
      marginRight: 5,
    },
    '& .add-image-content .pagination-control-container .btn.btn-default': {
      border: 'none',
    },
    '& .add-image-content .pagination-control-container .btn.btn-default:disabled': {
      backgroundColor: 'inherit',
    },
    '& .add-image-content .pagination-control-container .btn.btn-default:disabled .glyphicon': {
      color: '#a2a2a2',
    },
    '& .add-image-content .pagination-control-container span': {
      marginRight: 5,
    },
    '& .add-image-content .existing-opt-in-disclaimer': {
      marginTop: 15,

      '& .middle-info.btn-link': {
        paddingRight: 0,
      },

      '& .btn-link': {
        color: palette.themePrimary,
      },
    },
    '& .add-image-button': {
      margin: '10px 0',
      background: '#008272',
    },
    '& .panel-body > .react-block-ui-none, .panel-body > .react-block-ui': {
      height: '100%',
    },
    '& .add-image-content-container': {
      width: 1059,
      height: '100%',
      '&.image-selector-for-thumbnail': {
        width: '100%',
      },
    },

    '& .image-suggestion-picker-container': {
      '& + div > div > div, .react-block-ui > div:last-child > div > div': {
        flexDirection: 'column',
      },
      '& + div .blocker-image, .react-block-ui > div:last-child > div > div > .blocker-image': {
        margin: '0 auto 8px auto !important',
      },
    },
    '& .image-suggestion-picker-container > div > .subdomain-fields': {
      marginTop: 16,
      '& .divider': {
        display: 'inline-block',
        marginLeft: 10,
        marginRight: 10,
        fontSize: 14,
        lineHeight: '20px',
      },
    },
    '& .image-suggestion-picker-container > div > .suggestion-error': {
      marginTop: 16,
      display: 'inline-block',
      marginLeft: 271,
      fontSize: 14,
      lineHeight: '20px',
      '& img': {
        marginLeft: 129,
        marginBottom: 24,
      },
      '& .suggestion-error-invalid': {
        marginTop: 16,
        color: 'red',
      },
    },

    ...addEditCommonStyle({ iconFontFamily }),
    ...paginationStyle({ iconFontFamily }),
    ...panelStyle(),
    '& .add-video-content-container .upload-choice-group': {
      marginTop: -4,
      '& .ms-Label': {
        fontWeight: 400,
        marginBottom: 6,
      },
    },
    '& .add-video-content-container .ms-ChoiceField:first-child': {
      marginTop: 26,
    },
    '& .add-video-content-container .ms-ChoiceField:nth-child(2)': {
      marginTop: 10,
    },
    '& .add-video-content-container .ms-ChoiceField-field': {
      padding: 0,
      fontWeight: 400,
    },
    '& .add-video-content-container .upload-local-file-container': {
      display: 'flex',
      alignItems: 'flex-start',
      marginTop: 20,
      marginLeft: 26,
    },
    '& .add-video-content-container .upload-progress-container': {
      marginLeft: 26,
      paddingTop: 4,
      '& .bar-upload-progress': {
        width: 400,
      },
      '& .bar-upload-progress-text': {
        marginTop: -10,
      },
    },
    '& .add-video-content-container .cancel-upload-button': {
      marginLeft: 26,
    },
    '& .add-video-content-container .file-picker-input': {
      display: 'inline-block',
      width: 400,
    },
    '& .add-video-content-container .file-picker-container': {
      display: 'inline-block',
      marginLeft: 8,
      '& .file-picker-react-wrapper': {
        padding: 0,
      },
    },
    '& .add-video-content-container .image-url-container': {
      background: palette.white,
      width: 500,
      display: 'flex',
      marginTop: 20,
      marginLeft: 26,
      '& .image-url-input': {
        extend: controlStyle()['.form-control'],
        width: 400,
        display: 'inline-block',
      },

      '& #image-url-field, #image-description-field': {
        width: '100%',
      },

      '& .image-url-button': {
        extend: btnStyle()['.btn-default'],
        display: 'inline-block',
        marginLeft: 8,
        width: 130,
      },
    },
  },
  '@global': {
    '.popover-content': {
      overflow: 'auto',
      'max-height': '500px',
    },
  },
});

export const getStockPhotoFilterStyle = (components, { palette: themePalette = {} }) => ({
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > .predicate-list': {
      paddingLeft: 0,
    },
    '& .add-filter-button': {
      background: 'transparent',
      marginLeft: 0,
      '&:focus': {
        background: 'transparent',
      },
      '&:focus:after': {
        border: 0,
      },
    },
    '& .filter-bar-button': {
      height: '56px',
      border: 0,
      '&:focus:after': {
        border: 0,
      },
      '& .iconba': {
        color: themePalette.themePrimary,
      },
    },
    '& .btn:focus': {
      outline: '1px solid',
    },
    '& .selector-placeholder.labels-selector': predicateValueEditorStyle.selector({ palette: themePalette }),
  },
});

export const getCircleProgressStyle = () => ({
  circle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .radial-progress-text': {
      textAlign: 'center',
      display: 'block',
      color: 'white',
      fontSize: 10,
      fontWeight: 600,
    },
  },
});
